/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Stat_ProjectsInputs */



/**
* | output |
* | --- |
* | "projects" |
*
* @param {Overview_Stat_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overview_stat_projects = /** @type {((inputs?: Overview_Stat_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Stat_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte")
	return /** @type {LocalizedString} */ ("projects")
});